import React from 'react';
import { fileUrl } from '../../api';

export default function Clients({ clients }) {
  const row = [...clients, ...clients];
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="egea-container">
        <div className="flex items-center gap-4 mb-10">
          <span className="section-eyebrow whitespace-nowrap">Clienții noștri</span>
          <span className="flex-1 section-line" />
          <span className="text-[13px] text-slate-500 whitespace-nowrap">{clients.length}+ parteneri activi</span>
        </div>
      </div>

      <div className="relative overflow-hidden">
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-l from-white to-transparent" />
        <div className="egea-marquee-track items-center">
          {row.map((c, i) => (
            <div
              key={`${c.id}-${i}`}
              className="mx-4 flex items-center justify-center h-[76px] w-[168px] border border-slate-200 bg-slate-50 px-6 shrink-0"
              title={c.name}
            >
              <img
                src={fileUrl(c.logo)}
                alt={c.name}
                loading="lazy"
                className="max-h-[42px] max-w-[120px] object-contain opacity-70 hover:opacity-100 transition-opacity duration-300"
                style={{ filter: 'grayscale(1)' }}
                onMouseEnter={(e) => (e.currentTarget.style.filter = 'grayscale(0)')}
                onMouseLeave={(e) => (e.currentTarget.style.filter = 'grayscale(1)')}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
